import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import "./monastery.css";
import { MdAccessTime, MdLocationOn, MdPeople, MdEmail, MdPhone, MdPerson, MdNotes, MdEvent, MdAttachMoney  } from "react-icons/md";

function Monastery() {
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    setUser(currentUser);

    if (currentUser) {
      fetchUserDonations(currentUser.email);
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUserDonations = async (userEmail) => {
    try {
      const db = getFirestore();
      const donationsRef = collection(db, "monasteryDonations");
      const q = query(donationsRef, where("email", "==", userEmail));
      
      const querySnapshot = await getDocs(q);
      const donationsData = [];
      
      querySnapshot.forEach((doc) => {
        donationsData.push({
          id: doc.id,
          ...doc.data(),
          // Convert Firestore timestamp to readable date
          createdAt: doc.data().createdAt?.toDate().toLocaleString() || "Unknown date"
        });
      });

      setDonations(donationsData);
    } catch (error) {
      console.error("Error fetching donations:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="hero-container">
        <div className="hero-image-container">
          <img src="/dharma.png" alt="Alms Offering" />
        </div>
        <div className="hero-content">
          <h1>Ehipassiko Buddhist Centre</h1>
          <p>
            Let us come together in harmony, share in this noble practice,
            and receive the boundless blessings of the Triple Gem.
          </p>
        </div>
      </section>

      <div className="monastery-container">
        {loading ? (
          <p>Loading your donations...</p>
        ) : user ? (
          donations.length > 0 ? (
            <div className="donations-list">
              
              {donations.map((donation) => (
                <div key={donation.id} className="donation-card">
                  <div className="donation-header">
                    <h3>Donation</h3>
                    <span className="donation-amount">
                      {donation.amount} {donation.currency}
                    </span>
                  </div>
                  <div className="donation-details">
                    <p><MdPerson /> {donation.firstName} {donation.lastName}</p>
                    <p><MdEmail /> {donation.email}</p>
                    <p><MdPhone /> {donation.phone}</p>
                    <p><MdLocationOn /> {donation.address}</p>
                    <p><MdEvent /> {donation.donationDate}</p>
                    <p><MdAttachMoney /> {donation.amount} {donation.currency}</p>
                    {donation.reason && <p><MdNotes /> Reason: {donation.reason}</p>}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="no-abstraction">
              You haven't made any donations yet. <br /><br />
              With hearts full of reverence, we warmly invite you to be part
              of our spiritual activities at the Ehipassiko Buddhist Center.
            </p>
          )
        ) : (
          <p className="no-abstraction">
            Please sign in to view your donations.
          </p>
        )}
      </div>
    </>
  );
}

export default Monastery;